module.exports = __webpack_public_path__ + "soundtouch-speech-processor-d56a03ab.js";